"use client";

import { BreadcrumbProvider } from "@nrldigitaltechnology/ui-community";

export const BreadcrumbsClient = ({ children }: { children: React.ReactNode }) => {
  const initials = [{ id: "/competitions", label: "Home" }];
  return <BreadcrumbProvider initials={initials}>{children}</BreadcrumbProvider>;
};
